<template>
    <section id="about" class="about-section">
        <div class="container about-layout">
            <div class="section-identifier">
                {{ t.about.section }}
            </div>

            <div class="about-content">
                <p class="eyebrow">
                    <span></span>
                    {{ t.about.eyebrow }}
                </p>

                <h2>
                    {{ t.about.titleFirst }}
                    <em>{{ t.about.titleSecond }}</em>
                </h2>

                <div class="about-information">
                    <p>{{ t.about.paragraphOne }}</p>
                    <p>{{ t.about.paragraphTwo }}</p>
                </div>

                <div class="about-details">
                    <article>
                        <strong>1+</strong>
                        <span>
                            {{ language === 'es' ? 'Años de experiencia' : 'Years of experience' }}
                        </span>
                    </article>

                    <article>
                        <strong>16+</strong>
                        <span>
                            {{ language === 'es' ? 'Ciudades atendidas' : 'Cities served' }}
                        </span>
                    </article>

                    <article>
                        <strong>100%</strong>
                        <span>
                            {{ language === 'es' ? 'Compromiso con la calidad' : 'Commitment to quality' }}
                        </span>
                    </article>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: 'AboutSection',

  props: {
    t: {
      type: Object,
      required: true
    },

    language: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
    .about-section {
        position: relative;
        padding-block: var(--section-padding);
        overflow: hidden;
        background-color: var(--color-concrete);
    }

        .about-section::before {
            position: absolute;
            top: 0;
            right: 6%;
            width: 1px;
            height: 100%;
            background-color: rgba(32, 32, 32, 0.08);
            content: "";
        }

    .about-layout {
        display: grid;
        grid-template-columns: 24% 1fr;
        gap: 55px;
    }

    .section-identifier {
        display: flex;
        align-items: flex-start;
        gap: 14px;
        padding-top: 5px;
        color: #77736c;
        font-size: 10px;
        font-weight: 800;
        letter-spacing: 0.2em;
        text-transform: uppercase;
    }

        .section-identifier span {
            display: grid;
            width: 33px;
            height: 33px;
            place-items: center;
            color: var(--color-orange-dark);
            border: 1px solid var(--color-border);
            font-size: 9px;
        }

    .about-content {
        max-width: 980px;
    }

    .eyebrow {
        display: flex;
        align-items: center;
        gap: 13px;
        margin-bottom: 25px;
        color: var(--color-orange-dark);
        font-size: 10px;
        font-weight: 800;
        letter-spacing: 0.21em;
        text-transform: uppercase;
    }

        .eyebrow span {
            width: 32px;
            height: 2px;
            background-color: currentColor;
        }

    h2 {
        max-width: 900px;
        margin: 0;
        color: var(--color-charcoal);
        font-family: var(--font-heading);
        font-size: clamp(50px, 5.3vw, 82px);
        font-weight: 400;
        letter-spacing: -0.045em;
        line-height: 0.98;
    }

        h2 em {
            display: block;
            color: var(--color-orange);
            font-weight: 400;
        }

    .about-information {
        display: grid;
        max-width: 920px;
        margin-top: 55px;
        grid-template-columns: repeat(2, 1fr);
        gap: 50px;
    }

        .about-information p {
            margin: 0;
            color: var(--color-muted);
            font-size: 16px;
            line-height: 1.8;
        }

    .about-details {
        display: grid;
        margin-top: 65px;
        padding-top: 35px;
        grid-template-columns: repeat(3, 1fr);
        border-top: 1px solid var(--color-border);
    }

        .about-details article {
            display: flex;
            min-height: 80px;
            padding-right: 35px;
            flex-direction: column;
            border-right: 1px solid var(--color-border);
        }

            .about-details article:not(:first-child) {
                padding-left: 35px;
            }

            .about-details article:last-child {
                border-right: 0;
            }

        .about-details strong {
            color: var(--color-orange-dark);
            font-family: var(--font-heading);
            font-size: 38px;
            font-weight: 400;
            line-height: 1;
        }

        .about-details span {
            margin-top: 12px;
            color: var(--color-muted);
            font-size: 9px;
            font-weight: 800;
            letter-spacing: 0.14em;
            line-height: 1.5;
            text-transform: uppercase;
        }

    @media (max-width: 900px) {
        .about-layout {
            grid-template-columns: 1fr;
            gap: 40px;
        }

        .about-information {
            margin-top: 40px;
            gap: 25px;
        }
    }

    @media (max-width: 620px) {
        .about-information {
            grid-template-columns: 1fr;
        }

        .about-details {
            grid-template-columns: 1fr;
        }

            .about-details article {
                min-height: auto;
                padding: 24px 0;
                border-right: 0;
                border-bottom: 1px solid var(--color-border);
            }

                .about-details article:not(:first-child) {
                    padding-left: 0;
                }

                .about-details article:last-child {
                    border-bottom: 0;
                }
    }
</style>